import { render } from "./SpecialWatermelonComponent.vue?vue&type=template&id=179df25e&scoped=true"
import script from "./SpecialWatermelonComponent.vue?vue&type=script&lang=js"
export * from "./SpecialWatermelonComponent.vue?vue&type=script&lang=js"

import "./SpecialWatermelonComponent.vue?vue&type=style&index=0&id=179df25e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-179df25e"]])

export default __exports__